module.exports = __webpack_public_path__ + "img/SC.c4395313.svg";